export const formatPhoneNumber = (x) => {
    try {
        x = (x) ? x : "";
        x = (typeof x === "number") ? x.toString() : x;
        const arr = x.split("");
        if (arr.length === 11) {
            for (const i in arr) {
                if (i === "0")
                    arr[i] = `+${arr[i]} `;
                if (i === "3")
                    arr[i] = `${arr[i]} `;
                if (i === "6")
                    arr[i] = `${arr[i]}-`;
            }
            return arr.join("");
        }
        return x;
    }
    catch (err) {
        console.error(err);
    }
};
//# sourceMappingURL=format-phone-number.js.map